import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { DatastoreService } from "@src/app/helpers/datastore/datastore.service";
import { Project } from "@src/app/models/project";
import { Subscription } from "rxjs";

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: "app-projectprogress",
  templateUrl: "./projectprogress.component.html",
  styleUrls: ["./projectprogress.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectprogressComponent implements OnInit, OnChanges, OnDestroy {
  @Input() projectId: string;
  project: Project;
  @Input() fat: boolean;
  sub: Subscription;
  constructor(
    private datastore: DatastoreService, 
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {

  }

  ngOnInit(): void {
    this.sub = this.datastore.projectList$.pipe(untilDestroyed(this)).subscribe((plist) => {

      if (!this.projectId && this.route.snapshot.params.projectid) {
        this.projectId = this.route.snapshot.params.projectid;
        this.project = plist.find((x) => x.projectId == this.projectId);
        //console.log('progress from url',this.project);
      } else if (this.projectId) {
        this.project = plist.find((x) => x.projectId == this.projectId);
        //console.log('progress from input',this.project);
      }

      // Trigger change detection after updating from datastore
      this.cdr.markForCheck();
    });

  }
  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.projectId && changes.projectId.currentValue) {
      this.projectId = changes.projectId.currentValue;
      this.project = this.datastore.projectList
        .getValue()
        .find((x) => x.projectId == this.projectId);
      //console.log('on changes project',this.project);
      this.cdr.markForCheck();
    }
  }

}
